export const generatePeriodId = (startDate: Date, endDate: Date) => {
  const startYear = startDate.getFullYear()
  const startMonth = String(startDate.getMonth() + 1).padStart(2, '0')
  const endYear = endDate.getFullYear()
  const endMonth = String(endDate.getMonth() + 1).padStart(2, '0')
  return `${startYear}-${startMonth}_${endYear}-${endMonth}`
}
